import styled from "styled-components";
import { Toggle } from "@fluentui/react";

export const FilterContainer = styled.div`
    width: 100%;
    > div
    {
        button
        {
            min-width: 100%;
            > div
            {
                color: #95A0A1 !important;
                position: relative;
                span
                {
                    position: absolute;
                    right: -3px;
                }
                .ironia-icon
                {
                    position: absolute;
                    right: -25px;
                    top: -9px;
                    background: #CC214F;
                    width: 32px;
                    height: 32px;
                    border-radius: 100%;
                    &:after
                    {
                        font-size: 17px;
                        line-height: 32px;
                    }
                }
            }
        }
        .menu-footer
        {
            button
            {
                min-width: unset;
                width: 50%;
            }
        }
        span
        {
            border-radius: 100px;
        }
    }

    i
    {
        color: white;
    }
`;
export const ComparerTitle = styled.h3`
    margin-bottom: 0;
    cursor: default;
`;
export const ComparerDescription = styled.p`
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	color: #95A0A1;
    margin: 10px 0;
    cursor: default;
`;
export const RowComparer = styled.div`
`;
export const ColComparerTitle = styled.div``;
export const ColComparerDescription = styled.div`
    padding-top: 1em;
`;
export const ColComparerInput = styled.div`
    padding-top: 2em;
`;
export const MoneyToggle = styled(Toggle)`
    display: inline-block;
    margin-bottom: 0 !important;
    margin-top: 0.25em;
`;
export const ToggleLabel = styled.p`
    margin: 0;
    font-size: 15px;
    font-weight: 500;
`;
export const RowFirstBlock = styled.div`
`;
export const ColFirstGraphic = styled.div`
    min-height: 855px;
`;
export const FirstShadow = styled.div`
    min-height: 850px;
`;
export const RowGraphicSelector = styled.div``;
export const ColLinearGraphic = styled.div``;
export const TitleLinearGraphic = styled.h3`
    cursor: default;
`;
export const ColInfo = styled.div`
    margin-top: 4px;
`;
export const ColMoneyGraphic = styled.div``;
export const TitleMoneyGraphic = styled.h3`
    cursor: default;
`;
export const ColLeftToggleTitle = styled.div`
    cursor: default;
    margin-top: 0.25em;
`;
export const ColToggle = styled.div`
    cursor: pointer;
    text-align: center;
`;
export const ColRightToggleTitle = styled.div`
    cursor: default;
    margin-top: 0.25em;
`;
export const GraphicContainer = styled.div``;
export const DivGraphic = styled.div``;